<template>
    <div>
        <div class="card pkindex">
            <div class="card-body pk-header">
                <span>匹配对战</span>
                <button type="button" class="btn btn-success btn-lg" @click="open_pk_home">
                    返回
                </button>
            </div>
        </div>
    </div>

    <div class="matchground">
        <div class="match-alert" role="alert">
            <strong>注意事项</strong>
            <span>该模式下，使用 W、A、S、D 控制方向。</span>
        </div>

        <div class="row match-row">
            <div class="col-4">
                <div class="user-photo">
                    <img :src="$store.state.user.photo" alt="我的头像">
                </div>
                <div class="user-username">
                    {{ $store.state.user.username }}
                </div>
            </div>
            <div class="col-4">
                <div class="user-select-bot">
                    <select v-model="select_bot" class="form-select themed-select" aria-label="选择出战方式">
                        <option value="-1">亲自上阵</option>
                    </select>
                </div>
            </div>
            <div class="col-4">
                <div class="user-photo">
                    <img :src="$store.state.pk.opponent_photo" alt="对手头像">
                </div>
                <div class="user-username">
                    {{ $store.state.pk.opponent_username }}
                </div>
            </div>
            <div class="col-12 match-actions">
                <button type="button" class="btn btn-warning btn-lg" @click="click_match_btn">
                    {{ match_btn_info }}
                </button>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div v-if="showPopup" class="match-wait-toast" role="status" aria-live="polite">
            <div class="match-spinner" aria-hidden="true">
                <span class="match-spinner-ring"></span>
                <span class="match-spinner-dot"></span>
            </div>
            <div>
                <div class="match-toast-title">正在为你匹配对手</div>
                <div class="match-toast-meta">等待时间 {{ formattedWaitTime }}</div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { computed, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';

export default {
    setup() {
        const store = useStore();
        const match_btn_info = ref("开始匹配");
        const select_bot = ref("-1");
        const showPopup = ref(false);
        const waitSeconds = ref(0);
        let waitTimer = null;

        const formattedWaitTime = computed(() => {
            const minutes = String(Math.floor(waitSeconds.value / 60)).padStart(2, "0");
            const seconds = String(waitSeconds.value % 60).padStart(2, "0");
            return `${minutes}:${seconds}`;
        });

        const stopWaitTimer = () => {
            if (waitTimer) {
                clearInterval(waitTimer);
                waitTimer = null;
            }
        };

        const startWaitTimer = () => {
            stopWaitTimer();
            waitSeconds.value = 0;
            waitTimer = setInterval(() => {
                waitSeconds.value += 1;
            }, 1000);
        };

        const click_match_btn = () => {
            if (match_btn_info.value === "开始匹配") {
                match_btn_info.value = "取消匹配";
                showPopup.value = true;
                startWaitTimer();
                store.state.pk.socket.send(JSON.stringify({
                    event: "start-matching",
                    bot_id: select_bot.value,
                }));
            } else {
                match_btn_info.value = "开始匹配";
                showPopup.value = false;
                stopWaitTimer();
                waitSeconds.value = 0;
                store.state.pk.socket.send(JSON.stringify({
                    event: "stop-matching",
                }));
            }
        };

        const open_pk_home = () => {
            router.push({ name: "pk_home" });
        };

        onUnmounted(() => {
            stopWaitTimer();
        });

        return {
            match_btn_info,
            click_match_btn,
            select_bot,
            open_pk_home,
            showPopup,
            formattedWaitTime,
        };
    }
};
</script>

<style scoped>
div.pkindex {
    width: 60vw;
    min-height: 76px;
    margin: 18px auto 12px;
    background: var(--app-surface);
    border: 1px solid var(--app-border);
    border-radius: var(--app-radius-lg);
}

.pk-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.pk-header span {
    color: var(--app-primary);
    font-size: 1.7rem;
    font-weight: 900;
}

div.matchground {
    width: 60vw;
    min-height: 72vh;
    background: var(--app-surface);
    border: 1px solid var(--app-border);
    border-radius: var(--app-radius-lg);
    box-shadow: var(--app-shadow);
    margin: 16px auto 28px;
    padding: 18px;
    backdrop-filter: blur(18px);
}

.match-alert {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    align-items: center;
    margin: 0 auto 34px;
    padding: 16px 18px;
    color: var(--app-text);
    background: rgba(20, 184, 166, 0.12);
    border: 1px solid rgba(20, 184, 166, 0.28);
    border-radius: 12px;
}

.match-alert strong {
    color: var(--app-primary);
}

.match-row {
    align-items: center;
}

.user-photo {
    text-align: center;
    padding-top: 6vh;
}

.user-photo>img {
    width: 20vh;
    aspect-ratio: 1;
    object-fit: cover;
    border: 4px solid rgba(20, 184, 166, 0.32);
    border-radius: 50%;
    box-shadow: var(--app-shadow-soft);
}

.user-username {
    text-align: center;
    color: var(--app-text);
    padding-top: 2vh;
    font-size: 24px;
    font-weight: 800;
}

.user-select-bot {
    padding-top: 14vh;
}

.user-select-bot>select {
    width: 62%;
    min-height: 44px;
    margin: 0 auto;
}

.themed-select {
    background: var(--app-surface-strong);
    color: var(--app-text);
    border-color: var(--app-border);
}

.themed-select:focus {
    background: var(--app-surface-strong);
    color: var(--app-text);
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.2);
}

.match-actions {
    padding-top: 5vh;
    text-align: center;
}

.match-wait-toast {
    position: fixed;
    top: 112px;
    left: 50%;
    z-index: 2600;
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 280px;
    padding: 14px 18px;
    color: var(--app-text);
    background: color-mix(in srgb, var(--app-surface-strong) 94%, transparent);
    border: 1px solid rgba(20, 184, 166, 0.34);
    border-radius: 16px;
    box-shadow: 0 18px 46px rgba(15, 23, 42, 0.2);
    transform: translateX(-50%);
    backdrop-filter: blur(18px);
    animation: match-toast-in 0.22s ease both;
}

.match-spinner {
    position: relative;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 50%;
    box-shadow: 0 0 18px rgba(20, 184, 166, 0.2);
}

.match-spinner-ring,
.match-spinner-dot {
    position: absolute;
    inset: 0;
    border-radius: 50%;
}

.match-spinner-ring {
    background:
        radial-gradient(circle at center, var(--app-surface-strong) 56%, transparent 58%),
        conic-gradient(from 0deg, var(--app-primary), #2563eb 42%, rgba(20, 184, 166, 0.08) 72%, rgba(20, 184, 166, 0.18));
    animation: match-ring-spin 0.85s linear infinite;
    will-change: transform;
}

.match-spinner-dot {
    animation: match-dot-orbit 0.85s linear infinite;
    will-change: transform;
}

.match-spinner-dot::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    width: 10px;
    height: 10px;
    background: #2563eb;
    border-radius: 50%;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18), 0 0 14px rgba(37, 99, 235, 0.9);
    transform: translateX(-50%);
}

.match-toast-title {
    font-weight: 900;
}

.match-toast-meta {
    margin-top: 2px;
    color: var(--app-muted);
    font-size: 0.9rem;
    font-weight: 700;
}

@keyframes match-ring-spin {
    to {
        transform: rotate(1turn);
    }
}

@keyframes match-dot-orbit {
    to {
        transform: rotate(1turn);
    }
}

@keyframes match-toast-in {
    from {
        opacity: 0;
        transform: translate(-50%, -8px);
    }

    to {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}

@media (max-width: 992px) {
    div.pkindex,
    div.matchground {
        width: calc(100% - 24px);
    }

    .user-photo {
        padding-top: 4vh;
    }

    .user-photo>img {
        width: 14vh;
    }

    .user-select-bot {
        padding-top: 7vh;
    }

    .user-select-bot>select {
        width: 92%;
    }

    .match-wait-toast {
        top: 96px;
        width: calc(100% - 32px);
        min-width: 0;
    }
}
</style>
